export default __webpack_public_path__ + "static/abhishek-chandra-7e45c14b1578a883bac3a2025152cc9f.svg";